var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                page: _vm.page,
                data: _vm.tableData,
                permission: _vm.permissionList,
                "table-loading": _vm.tableLoading,
                option: _vm.tableOption,
                "before-open": _vm.beforeOpen,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "search-change": _vm.searchChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-del": _vm.rowDel,
              },
              scopedSlots: _vm._u([
                {
                  key: "menu",
                  fn: function (scope) {
                    return [
                      _vm.permissions.sys_dict_add
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                size: "small",
                                icon: "el-icon-menu",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleItem(scope.row, scope.index)
                                },
                              },
                            },
                            [_vm._v("字典项\n        ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.sys_dict_del
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-refresh-left",
                          },
                          on: { click: _vm.handleRefreshCache },
                        },
                        [_vm._v("缓存\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            title: "字典项管理",
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.dictItemVisible,
          },
        },
        [
          _c("avue-crud", {
            ref: "crudItem",
            attrs: {
              page: _vm.itemPage,
              data: _vm.tableDictItemData,
              permission: _vm.permissionList,
              "before-open": _vm.handleBeforeOpen,
              option: _vm.tableDictItemOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.itemPage = $event
              },
              "size-change": _vm.itemSizeChange,
              "current-change": _vm.itemCurrentChange,
              "row-update": _vm.handleItemUpdate,
              "row-save": _vm.handleItemSave,
              "row-del": _vm.rowItemDel,
            },
            model: {
              value: _vm.form,
              callback: function ($$v) {
                _vm.form = $$v
              },
              expression: "form",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }